import { groupBy, map } from 'lodash';

/**
 * 处理项目编辑时的规则列表，归组分类
 * @param {Array} ruleList
 */
export function handleProjRulelList(ruleList) {
  // 分组
  let ruleArrObj = groupBy(ruleList, function(n) {
    return n['typeName'];
  });
  let ruleArr = [];
  // 组装
  Object.keys(ruleArrObj).forEach(function(key, index) {
    // let ruleResult = false;
    map(ruleArrObj[key], function(n) {
      // n['index'] = index + 1;
      n['ruleContent'] = JSON.parse(n['ruleContent']);

      if (n['ruleResult'] !== true) {
        n['ruleResult'] = n['ruleResult'] === 'true' || n['ruleResult'] === '1';
      }
      return n;
    });

    ruleArr.push({
      ruleType: ruleArrObj[key][0]['typeName'],
      ruleItem: ruleArrObj[key],
      groupSort: key
    });
  });
  return ruleArr;
}

/**
 * 处理项目查看时的规则列表，归组分类
 * @param {Array} ruleList
 */
export function handleProjViewRuleList(ruleList) {
  // 分组
  let ruleArrObj = groupBy(ruleList, function(n) {
    return n['typeName'];
  });
  let ruleArr = [];
  // 组装
  Object.keys(ruleArrObj).forEach(function(key, index) {
    // let ruleResult = false;
    map(ruleArrObj[key], function(n) {
      // n['index'] = index + 1;
      n['ruleContent'] = JSON.parse(n['ruleContent']);

      if (n['ruleResult'] !== true) {
        n['ruleResult'] = n['ruleResult'] === 'true' || n['ruleResult'] === '1';
      }
      return n;
    });

    ruleArrObj[key] = ruleArrObj[key].filter(item => {
      return item.ruleResult === true;
    });

    if (ruleArrObj[key].length > 0) {
      ruleArr.push({
        ruleType: ruleArrObj[key][0]['typeName'],
        ruleItem: ruleArrObj[key],
        groupSort: key
      });
    }
  });
  return ruleArr;
}

/**
 * 规则应答编辑列表处理
 * @param {Array} ruleAnswerList
 */
export function handleProjRuleAnswerList(ruleAnswerList) {
  return handleProjViewRuleList(ruleAnswerList);
}

/**
 * 计算获取页面导航配置信息
 * @param {导航配置数组} navArr
 * @param {待替换的导航参数} params
 */
export function calcNavArr(navArr, params) {
  navArr.forEach(item => {
    Object.keys(params).forEach(ele => {
      item.params = item.params.replace('{' + ele + '}', params[ele]);
    });
  });
}
